import React, { useState, useEffect } from 'react';
import { ref, onValue } from 'firebase/database';
import { database } from '../firebase';
import './Testimonials.css';

const Testimonials = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const testimonialsRef = ref(database, 'testimonials');
    const unsubscribe = onValue(testimonialsRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const testimonialsList = Object.keys(data).map(key => ({
          id: key,
          ...data[key]
        }));
        setTestimonials(testimonialsList);
      } else {
        setTestimonials([]);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (testimonials.length === 0) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [testimonials.length]);

  return (
    <section id="testimonials" className="testimonials">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Müşteri Yorumları</h2>
          <p className="section-subtitle">
            Müşterilerimizin deneyimlerini keşfedin
          </p>
        </div>
        {loading || testimonials.length === 0 ? (
          <div className="testimonials-empty">
            <p>Henüz müşteri yorumu eklenmemiş.</p>
          </div>
        ) : (
          <>
            <div className="testimonials-slider">
              <div className="testimonials-track" style={{ transform: `translateX(-${currentIndex * 100}%)` }}>
                {testimonials.map((testimonial) => {
                  const rating = testimonial.rating || 5;
                  return (
                    <div key={testimonial.id} className="testimonial-item">
                      <div className="testimonial-content">
                        <div className="testimonial-stars">
                          {Array.from({ length: 5 }, (_, i) => (
                            <span key={i} className={i < rating ? 'star-filled' : 'star-empty'}>★</span>
                          ))}
                        </div>
                        <p className="testimonial-text">"{testimonial.comment}"</p>
                        <div className="testimonial-author">
                          <strong>{testimonial.name}</strong>
                          {testimonial.company && <span className="testimonial-company"> - {testimonial.company}</span>}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="testimonials-dots">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  className={`testimonial-dot ${index === currentIndex ? 'active' : ''}`}
                  onClick={() => setCurrentIndex(index)}
                  aria-label={`Yorum ${index + 1}`}
                />
              ))}
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default Testimonials;
